import * as process from 'process';

// @dynamic
export class Util {
	static enumNameByVal(enumm: any, val: any) {
		return Object.keys(enumm).find(key => enumm[key] === val);
	}

}

export function logErr(err) {
    process.stderr.write('ERR' + err + '\r\n');
}

export function LogLn(msg){
	return process.stdout.write(msg + '\r\n')
}

export function Log(msg){
    return process.stdout.write(msg)
}
